import React, { useState } from "react";
import { Eye, EyeOff, LogIn } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

const fieldClass = "mt-2 min-h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm text-slate-900 outline-none placeholder:text-slate-400 focus:border-amber-400 dark:border-[#353b46] dark:bg-[#191d26] dark:text-white dark:placeholder:text-slate-500";

export default function ProviderPortalSignIn() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const result = await login(email.trim(), password);
      if (!result.success) setError(t(result.errorKey || "auth.invalid_credentials"));
    } catch {
      setError(t("auth.invalid_credentials"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-6 space-y-4 text-left">
      {error && <p role="alert" className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700 dark:border-red-400/20 dark:bg-red-400/10 dark:text-red-200">{error}</p>}
      <label className="block text-sm font-bold text-slate-700 dark:text-slate-200">
        {t("auth.email_label")}
        <input type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} placeholder={t("auth.email_placeholder")} className={fieldClass} />
      </label>
      <div>
        <label htmlFor="portal-password" className="block text-sm font-bold text-slate-700 dark:text-slate-200">{t("auth.password_label")}</label>
        <div className="relative">
          <input id="portal-password" type={showPassword ? "text" : "password"} autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)} placeholder={t("auth.password_placeholder")} className={`${fieldClass} pr-12`} />
          <button type="button" onClick={() => setShowPassword((visible) => !visible)} aria-label={t(showPassword ? "auth.hide_password" : "auth.show_password")} aria-pressed={showPassword} className="absolute bottom-0 right-3 flex h-12 items-center justify-center px-1 text-slate-500 transition hover:text-amber-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 dark:text-slate-400 dark:hover:text-amber-300">
            {showPassword ? <EyeOff className="h-5 w-5" aria-hidden="true" /> : <Eye className="h-5 w-5" aria-hidden="true" />}
          </button>
        </div>
      </div>
      <button type="submit" disabled={busy} className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-2xl bg-amber-400 px-5 text-sm font-extrabold text-slate-950 transition hover:bg-amber-300 disabled:opacity-60">
        <LogIn className="h-4 w-4" aria-hidden="true" />{busy ? t("auth.loading") : t("auth.login_btn")}
      </button>
    </form>
  );
}
